import { useCallback, useMemo, useState } from "react";

import dayjs from "@/lib/dayjs";

import type * as Constants from "./constants";
import type * as Type from "./type";

export const useSearchModel = () => {
	/**
	 * state の初期値
	 */
	const initSearchModel = useMemo((): Type.SearchModel => {
		const now = dayjs();
		const year = now.year();
		const month = now.month() + 1;
		const startDate = now.startOf("month").date();
		const endDate = now.endOf("month").date();

		return {
			searchCondition: {
				year,
				month,
				startDate,
				endDate,
				selectedDate: undefined,
			},
			selectedReservationType: undefined,
		};
	}, []);
	const [searchModel, setSearchModel] = useState<Type.SearchModel>(initSearchModel);

	/**
	 * 前月へ
	 */
	const onPrevMonth = useCallback(() => {
		const current = dayjs()
			.year(searchModel.searchCondition.year)
			.month(searchModel.searchCondition.month - 1);
		const prevMonth = current.subtract(1, "month");

		const year = prevMonth.year();
		const month = prevMonth.month() + 1;
		const startDate = prevMonth.startOf("month").date();
		const endDate = prevMonth.endOf("month").date();

		setSearchModel((prev) => ({
			...prev,
			searchCondition: {
				year,
				month,
				startDate,
				endDate,
				selectedDate: undefined,
			},
		}));
	}, [searchModel.searchCondition.month, searchModel.searchCondition.year]);
	/**
	 * 翌月へ
	 */
	const onNextMonth = useCallback(() => {
		const current = dayjs()
			.year(searchModel.searchCondition.year)
			.month(searchModel.searchCondition.month - 1);
		const nextMonth = current.add(1, "month");

		const year = nextMonth.year();
		const month = nextMonth.month() + 1;
		const startDate = nextMonth.startOf("month").date();
		const endDate = nextMonth.endOf("month").date();

		setSearchModel((prev) => ({
			...prev,
			searchCondition: {
				year,
				month,
				startDate,
				endDate,
				selectedDate: undefined,
			},
		}));
	}, [searchModel.searchCondition.month, searchModel.searchCondition.year]);

	/**
	 * 予約タイプかつ日付の選択
	 */
	const onSelectReservationTypeWithDate = useCallback(
		(selectedDate: number, selectedReservationType: Constants.ReservationTypeForSearchReservationList) => {
			setSearchModel((prev) => ({
				...prev,
				searchCondition: {
					...prev.searchCondition,
					selectedDate,
				},
				selectedReservationType,
			}));
		},
		[],
	);

	return {
		searchModel,
		// 月の切り替え
		onPrevMonth,
		onNextMonth,
		// 予約タイプかつ日付の選択
		onSelectReservationTypeWithDate,
	};
};
